import React from "react";
import { useTranslation } from "react-i18next";
import { RadioButtons } from "../../../FlowConfigurationInputs";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description this page String Library's Search Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Search({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const options = {
    radioButtons: {
      data: [
        {
          value: "active",
          label: label + "MATCHCASE",
        },
        {
          value: "passive",
          label: label + "NOTMATCHCASE",
        },
      ],
      defaultValue: "active",
    },
  };

  return (
    <div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "SOURCESTRING")} is_required />
        <TextInput
          action={action}
          inputName="sourceString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          displayName={t(label + "SOURCESTRING")}
          fieldType={"string"}
          hideRequired
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "FINDSTRING")} is_required />
        <TextInput
          action={action}
          inputName="findString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          displayName={t(label + "FINDSTRING")}
          fieldType={"string"}
          hideRequired
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "FINDING")} />
        <RadioButtons
          action={action}
          inputName="isMatchCase"
          isRequired={true}
          options={options.radioButtons}
        />
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")} is_required />
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired
          hideRequired
        />
      </div>
    </div>
  );
}
